import { Alert, alpha, Button, Divider, Icon, LinearProgress, Menu, MenuItem, MenuProps, styled } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { userLicenseService } from "../../_services/userLicense.service";
import { formService } from "../../_services/form.service";
import { FormTemplateTypeEnum } from "../../_common/enum/forms/fomTemplateType.enum";
import { accountService } from "../../_services/accounts.service";
import { UserCreditManageDrawer } from "../userCredit/userCredit-manageDrawer";

const StyledMenu = styled((props: MenuProps) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color: 'rgb(55, 65, 81)',
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
        ...theme.applyStyles('dark', {
            color: theme.palette.grey[300],
        }),
    },
}));


export function InfoManageLicenseButton() {

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [isIrdsLoading, setIsIrdsLoading] = useState(false);
    const [isFormsLoading, setIsFormsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isIrdsRequired, setIsIrdsRequired] = useState(false);

    const [creditManagerOpen, setCreditManagerOpen] = useState(false);


    const [forms, setForms] = useState([]);
    const { userId } = useParams<{ userId: string }>();
    let navigate = useNavigate();

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const navigateTo = (formTemplateType: FormTemplateTypeEnum) => {
        var form: any = findForm(formTemplateType);
        !form ? (FormTemplateTypeEnum.CompetitionLicenceApplication == formTemplateType ? navigate("./CompetitionLicenceApplication") : createForm(formTemplateType)) : navigate(`./Forms/${form.formId}`)
    };

    function createForm(type: FormTemplateTypeEnum) {
        setIsSaving(true);
        return formService.createByType(type, userId)
            .then(
                data => {
                    navigate("./Forms/" + data)
                }, handleErrorResponse)
            .finally(() => {
                setIsSaving(false);
            });
    }

    function findForm(formTemplateType: FormTemplateTypeEnum) {
        return forms && forms.length ? forms.find((m: any) => m.formTemplateTypeId == formTemplateType) : null;
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        fetchIrdsData();
        fetchFormsData();
    }, []);

    function fetchIrdsData() {

        setIsIrdsLoading(true)
        return userLicenseService
            .doesUserNeedIrds(userId || "")
            .then(
                (json) => {
                    setIsIrdsRequired(json)
                }, handleErrorResponse
            )
            .finally(() => {
                setIsIrdsLoading(false);
            });
    }

    function fetchFormsData() {
        setIsFormsLoading(true);
        return formService
            .getAllCurrent(userId || '')
            .then(
                (json) => {
                    console.log(json);
                    setForms(json);
                }
            )
            .finally(() => setIsFormsLoading(false));
    }

    return (
        <>

            {isIrdsLoading && <LinearProgress style={{ "marginBottom": "4px" }} />}
            {(!isIrdsLoading && isIrdsRequired) &&
                <Alert severity="error" style={{ "marginBottom": "4px" }}>
                    If you have applied for a Rally ITC-R, Rally National A, Rally National B or Clubman Road licence, please complete the IRDS form. Your licence cannot be processed without this.
                </Alert>
            }
            <Button
                id="demo-customized-button"
                aria-controls={open ? 'demo-customized-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                variant="contained"
                disableElevation
                onClick={handleClick}
                style={{ "width": "100%" }}
                endIcon={<Icon>expand_more</Icon>}
            >
                Apply / Renew
            </Button>

            {(userId && (!!accountService.isAdmin || !!accountService.isOrganiser)) &&
                <>
                    <Button
                        id="demo-customized-button"
                        aria-controls={open ? 'demo-customized-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        variant="contained"
                        disableElevation
                        onClick={() => { setCreditManagerOpen(true) }}
                        color="success"
                        style={{ "width": "100%", marginTop: "4px" }}
                        endIcon={<Icon>add</Icon>}
                    >
                        Add Credit Point
                    </Button>

                    {!!creditManagerOpen &&
                        <UserCreditManageDrawer
                            isOpen={!!creditManagerOpen}
                            itemId={null}
                            onSave={() => { setCreditManagerOpen(false); }}
                            onClose={() => { setCreditManagerOpen(false); }}
                        />
                    }
                </>
            }

            <StyledMenu

                id="demo-customized-menu"
                MenuListProps={{
                    'aria-labelledby': 'demo-customized-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <MenuItem disabled={isSaving} onClick={() => { navigateTo(FormTemplateTypeEnum.CompetitionLicenceApplication) }} disableRipple>
                    <Icon style={{ "marginTop": "-4px", "marginRight": "2px" }}>directions_car</Icon>
                    Competition Licence
                </MenuItem>
                <MenuItem disabled={isSaving} onClick={() => { navigateTo(FormTemplateTypeEnum.Official) }} disableRipple>
                    <Icon style={{ "marginTop": "-4px", "marginRight": "2px" }}>accessibility</Icon>
                    Official Licence
                </MenuItem>
                <MenuItem disabled={isSaving} onClick={() => { navigateTo(FormTemplateTypeEnum.Media) }} disableRipple>
                    <Icon style={{ "marginTop": "-4px", "marginRight": "2px" }}>radio</Icon>
                    Media Licence
                </MenuItem>
                <MenuItem disabled={isSaving} onClick={() => { navigateTo(FormTemplateTypeEnum.MinorEntrant) }} disableRipple>
                    <Icon style={{ "marginTop": "-4px", "marginRight": "2px" }}>supervisor_account</Icon>
                    Minor Entrant
                </MenuItem>
                <MenuItem disabled={isSaving} onClick={() => { navigateTo(FormTemplateTypeEnum.OneDayEvent) }} disableRipple>
                    <Icon style={{ "marginTop": "-4px", "marginRight": "2px" }}>event</Icon>
                    One Event
                </MenuItem>

                <Divider sx={{ my: 0.5 }} />

                <MenuItem disabled={isSaving} onClick={() => { navigateTo(FormTemplateTypeEnum.IRDS) }} disableRipple>
                    <Icon style={{ "marginTop": "-4px", "marginRight": "2px" }}>attach_money</Icon>
                    IRDS
                </MenuItem>
                <MenuItem disabled={isSaving} onClick={() => { navigateTo(FormTemplateTypeEnum.BRDS) }} disableRipple>
                    <Icon style={{ "marginTop": "-4px", "marginRight": "2px" }}>attach_money</Icon>
                    BRDS
                </MenuItem>

            </StyledMenu>
        </>
    );

}
